/**
 * RBAC helpers aligned with backend `src/config/permissions.js` screen keys.
 * `permissionScreen` on routes/sidebar maps to these keys; aliases cover legacy stored keys.
 */

export const SCREEN_ALIAS_KEYS: Record<string, string[]> = {
  dashboard: ['dashboard', 'home'],
  quotations: ['quotations', 'rfq_inbox'],
  orders: ['orders'],
  confirmed_orders: ['confirmed_orders', 'confirmed_order', 'confirmedorders'],
  vendor_purchase_orders: [
    'vendor_purchase_orders',
    'vendor_purchase_order',
    'vendorpo',
    'vendor_pos'
  ],
  invoices: ['invoices', 'confirmed_orders'],
  products: ['products'],
  // The catalogue-addition + packing-alerts review queue. No alias of its own
  // stored permissions key yet — an admin always passes regardless
  // (`hasScreenPermission`'s `role === 'admin'` shortcut), which is the only
  // way anyone reaches it today.
  catalogue_review: ['catalogue_review'],
  inventory: ['inventory'],
  financials: ['financials'],
  reports: ['reports'],
  users: ['users'],
  templates: ['templates'],
  settings: ['settings'],
  vendors: ['vendors', 'vendor', 'suppliers', 'supplier'],
  clients: ['clients', 'client', 'customers', 'customer']
};

type PermUser = {
  role?: string;
  permissions?: Record<string, { view?: boolean; edit?: boolean; create?: boolean; delete?: boolean; export?: boolean; import?: boolean }>;
};

function permRow(perms: PermUser['permissions'], key: string) {
  const p = perms?.[key] as any;
  if (p && typeof p === 'object' && p._doc) return p._doc;
  return p;
}

export function hasScreenPermission(
  user: PermUser | null,
  screen: string,
  type: 'view' | 'edit' | 'create' | 'delete' | 'export' | 'import' = 'view'
): boolean {
  if (!user) return false;
  if (user.role === 'admin') return true;
  const perms = user.permissions || {};
  const keys = SCREEN_ALIAS_KEYS[screen] || [screen];
  return keys.some((k) => permRow(perms, k)?.[type] === true);
}
